import http from "../../http-common";
/* eslint-disable */
class BankDataPenelitianService {
  bankDataPenelitianList(page, itemPerPage, keyword) {
    return http.get(
      "/bank-data/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("judul", data.judul);
    bodyFormData.append("author", data.author);
    bodyFormData.append("link_website", data.link_website);

    return http.post("/bank-data", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("judul", data.judul);
    bodyFormData.append("author", data.author);
    bodyFormData.append("link_website", data.link_website);

    return http.put(`/bank-data/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  delete(id) {
    return http.delete(`/bank-data/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new BankDataPenelitianService();
